export const pageGridContainerStyle = { height: '100%' };

export const maxWidth100 = { maxWidth: '100%' };
